import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {ConnectedRouter} from 'react-router-redux';
import {PersistGate} from 'redux-persist/integration/react'

// Import Semantic UI before Root
import 'semantic-ui-css/semantic.min.css';
import {Dimmer, Loader} from 'semantic-ui-react';

import registerServiceWorker from './utils/registerServiceWorker';
import {history, persistor, store} from './store';

import Root from './Root';

const loading = <Dimmer active={true} inverted={true}><Loader inverted={true}/></Dimmer>;

// Provide Redux store, connect Router and render Root
ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={loading} persistor={persistor}>
            <ConnectedRouter history={history}>
                <Root/>
            </ConnectedRouter>
        </PersistGate>
    </Provider>,
    document.getElementById(
        'root'
    )
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js